import type { enWorld } from './en-world';

/** Turkish strings — arena and boss names (docs/01 arenas, docs/02 bosses). */
export const trWorld: Record<keyof typeof enWorld, string> = {
  // Arenas
  'arena.void-open': 'Açık Alan',
  'arena.nebula-pillars': 'Dört Sütun',
  'arena.forest-corridor': 'Orta Duvar',
  'arena.void-corridor': 'Dar Koridor',
  'arena.nebula-expanse': 'Büyük Açıklık',
  'arena.forest-chasm': 'Uçurum Köprüleri',
  'arena.magma-cauldron': 'Kazan',
  'arena.void-ring': 'Taş Halka',
  'arena.abyss-trench': 'Batık Hendek',
  'arena.abyss-vortex': 'Obruk Halkası',
  'arena.magma-crossfire': 'Çapraz Ateş',
  'arena.nebula-gauntlet': 'Koşu Parkuru',
  'arena.void-fracture': 'Çatlak Zemin',
  'arena.forest-grove': 'Ulu Koru',

  // Bosses
  'boss.sentinel': 'GÖZCÜ',
  'boss.carrier': 'KRİSTAL TAŞIYICI',
  'boss.hive': 'KOVAN ANA',
  'boss.serpent': 'İKİZ YILANLAR',
  'boss.kraken': 'KRAKEN',
  'boss.centipede': 'KIRKAYAK',
  'boss.quartet': 'DÖRTLÜ',
  'boss.pyre': 'CEHENNEM ÇEKİRDEĞİ',
  'boss.prism': 'PRİZMA',
  'boss.tide': 'DERİN ÇAĞIRAN',
  'boss.null': 'HİÇLİK TACI',
  'boss.terra': 'GRANİT YUMRUK',
  'boss.gale': 'FIRTINA GÖZÜ',
  'boss.avatar': 'AVATAR',
  'boss.mirror': 'AYNACI',
  'boss.splitter': 'BÖLÜNEN',
  'boss.admiral': 'AMİRAL',
  'boss.chronos': 'SAATÇİ',
  'boss.magnet': 'MIKNATIS',
  'boss.bastion': 'KULE',
  'boss.stalker': 'AVCI',
  'boss.singularity': 'KARA DELİK',
  'boss.broodworm': 'SOLUCAN KRALİÇE',
  'boss.webspinner': 'LAZER ÖRÜMCEĞİ',
  'boss.warden': 'BEKÇİ',
};
